export default {
    setRideTypes (state, data) {
        state.rideTypes = data
    },
}
